import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./index";

const selectRosterImportDomain = (state) => state.rosterImport || initialState;

export const selectRosterRequests = createSelector(
  [selectRosterImportDomain],
  (rosterImportState) => rosterImportState.rosterRequests
);
